import { metaPosts } from './2026/meta';
import { infraPosts } from './2026/infra';
import { angularRxjsPosts } from './2026/angular-rxjs';
import { designArchPosts } from './2026/design';
import type { BlogPost } from '../../../app/features/blog/blog.types';

type RawPost = Omit<BlogPost, 'readingTimeMinutes'>;

export const RAW_POSTS_2026: readonly RawPost[] = [
  ...metaPosts,
  ...infraPosts,
  ...angularRxjsPosts,
  ...designArchPosts,
];
